import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Avatar, Box, IconButton, Menu, MenuItem, Toolbar } from "@mui/material";
import { useState } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";

export default function LawAppBar() {
    const [anchorEl, setAnchorEl] = useState(null);
    const [cookies, , removeCookie] = useCookies(['given_name', 'userid', 'picture', 'email', 'credential']);
    const navigate = useNavigate();

    return (
        <AppBar
            position="static"
            sx={{
                background: 'var(--background-color)',
                boxShadow: 'var(--shadow-subtle)',
                borderBottom: '1px solid var(--border-color)',
                color: 'var(--text-primary)'
            }}
        >
            <Toolbar
                variant="dense"
                sx={{
                    minHeight: '48px',
                    padding: '0 20px'
                }}
            >
                <IconButton
                    onClick={() => navigate('/mycases')}
                    size="small"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{
                        mr: 1.5,
                        color: 'var(--text-secondary)',
                        '&:hover': {
                            background: 'var(--surface-color)',
                            color: 'var(--text-primary)'
                        }
                    }}
                >
                    <MenuIcon />
                </IconButton>

                <Box
                    onClick={() => navigate('/mycases')}
                    sx={{
                        flexGrow: 1,
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                >
                    <img
                        src="/AttorneyAideLogo.png"
                        alt="AttorneyAide"
                        style={{
                            height: '32px',
                            maxWidth: '200px',
                            objectFit: 'contain'
                        }}
                    />
                </Box>

                {cookies.picture && (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar
                            src={cookies.picture}
                            onClick={handleMenu}
                            alt="profile"
                            referrerPolicy="no-referrer"
                            aria-controls="profile-menu"
                            sx={{
                                cursor: "pointer",
                                width: 32,
                                height: 32,
                                border: '1px solid var(--border-color)',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    border: '1px solid var(--text-secondary)'
                                }
                            }}
                        />
                        <Menu
                            id="profile-menu"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            PaperProps={{
                                sx: {
                                    mt: 1,
                                    minWidth: 120,
                                    borderRadius: 1,
                                    boxShadow: 'var(--shadow-light)',
                                    border: '1px solid var(--border-color)',
                                    '& .MuiMenuItem-root': {
                                        fontSize: '0.85rem',
                                        fontWeight: 400,
                                        color: 'var(--text-primary)',
                                        padding: '8px 16px',
                                        '&:hover': {
                                            background: 'var(--surface-color)'
                                        }
                                    }
                                }
                            }}
                        >
                            <MenuItem onClick={onLogoutClicked}>
                                Logout
                            </MenuItem>
                        </Menu>
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    );

    function handleMenu(event) {
        setAnchorEl(event.currentTarget);
    };

    function handleClose() {
        setAnchorEl(null);
    };

    function onLogoutClicked() {
        console.log('Removing cookies');
        removeCookie('given_name', { path: '/' });
        removeCookie('userid', { path: '/' });
        removeCookie('email', { path: '/' });
        removeCookie('picture', { path: '/' });
        removeCookie('credential', { path: '/' });
        console.log('After removing Cookie: ' + cookies.credential);

        setAnchorEl(null);
    }
}